import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';
import { closeLoading, showLoading } from '../../Reducer/LoadingReducer';

const useSaveMutation = (mutationFn, options = {}) => {
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn,

    onMutate: () => {
      dispatch(showLoading());
      options.onMutate?.();
    },

    onSuccess: (response, vars, context) => {
      // 응답 그대로 사용 - 파싱 불필요
      // if (response.severity === 'error') {
      //   const err = new Error(response.message);
      //   err.response = response;
      //   options.onError?.(err, vars, context);
      //   throw err;
      // }

      options.onSuccess?.(response, vars, context);
      return response;
    },

    onError: (e) => {
      options.onError?.(e);
    },

    onSettled: () => {
      dispatch(closeLoading());
      options.onSettled?.();
    },
  });

  return {
    ...mutation,
    run: (params) => mutation.mutate(params),
    runAsync: (params) => mutation.mutateAsync(params),
  };
};

export default useSaveMutation;
